import React, { useEffect, useState } from "react";
import CallAPI from "../../../../adminpanel/components/commonComponents/AxiosHelper";
import { connect } from 'react-redux';
import DataTableComponent from "../../commonComponents/DataTableComponent";
import LoadingComponent from '../../commonComponents/LoadingComponent';
//import BreadCrumb from '../../../../adminpanel/components/commonComponents/BreadCrumb';

const ViewRawData = ({ authData, match }) => {
    const [rawData, setRawData] = useState()
    const [errorMessage, setErrorMessage] = useState()
    let urlParams = match.params;

    useEffect(() => {
        let params = { "siteId": authData.siteId };
        let postData = {
            "tableName": `${urlParams.dbName}.${urlParams.tableName}`,
            "limit": 500,
        }
        if (urlParams.fileName) {
            postData.whereCondition = { "fileName": `${urlParams.fileName}.csv` }
        }
        CallAPI('post', '/app/view_raw_data', postData, params, 0, function (response) {
            if (response.status === true) {
                setRawData(response.information);
                setErrorMessage(null);
            } else {
                setRawData(response.status);
                setErrorMessage(response.error_message);
            }
        }, authData)
    }, [])

    let errorData = <h5 className="text-center mg-t-100">{errorMessage}</h5>
    let columnData = []
    rawData && Object.keys(rawData[0]).map(function (innerData) {
        columnData.push({ "virtualName": innerData, "rawField": innerData });
    })
    let displayData = {
        tableData: rawData ? rawData : null,
        columnData: columnData
    }
    return rawData && errorMessage === null ? <DataTableComponent tableData={displayData.tableData} columnData={displayData.columnData} paginationStatus={true} /> : rawData === false && errorMessage ? errorData : <LoadingComponent />
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData };
}

export default connect(mapStateToProps, null)(ViewRawData);